<div class="content">
    <div class="table-container mat-elevation-z3">
  
      <table mat-table [dataSource]="items" matSort matSortActive="method" matSortDirection="asc" matSortDisableClear
        [matSortDirection]="sortDirection" [matSortActive]="sortColumn" (matSortChange)="onSortData($event)">
  
        <ng-container matColumnDef="shopNumber">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'common.shop-number' | translate}} </th>
          <td mat-cell *matCellDef="let element"> {{element.shopNumber}} </td>
        </ng-container>
  
        <ng-container matColumnDef="method">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'reports.queues-status.method' | translate}} </th>
          <td mat-cell *matCellDef="let element">{{apiMethodEnum[element.method]}}</td>
        </ng-container>
  
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'reports.queues-status.status' | translate}} </th>
          <td mat-cell *matCellDef="let element"> {{'reports.queues-status.'+ statusEnum[element.status] | dashcase | translate}} </td>
        </ng-container>
  
        <ng-container matColumnDef="quantity">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'reports.queues-status.quantity' | translate}} </th>
          <td mat-cell *matCellDef="let element"> {{element.quantity}} </td>
        </ng-container>
  
        <ng-container *ngFor="let column of columns" [matColumnDef]="column.filter.name">
          <th mat-header-cell *matHeaderCellDef="let element">
            <app-table-filter [column]="column" [filter]="filter" (filterChange)="filterData($event)"></app-table-filter>
          </th>
        </ng-container>
  
        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-header-row *matHeaderRowDef="filterColumns; sticky: true" class="filters"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  
      </table>
  
      <div class="empty-results" *ngIf="items.length === 0">{{'common.empty-results' | translate}}
      </div>
  
      <mat-paginator [length]="totalRows" [pageSize]="pageSize" [pageIndex]="pageIndex" color="primary"
        [pageSizeOptions]="pageSizeOptions" (page)="pageEvent = $event; onPaginateChange($event)" showFirstLastButtons
        class="mat-paginator-row">
      </mat-paginator>
    </div>
  </div>